import { Injectable } from '@angular/core';
import { NbIconLibraries } from '@nebular/theme';
import icons from '../constants/facetsIconMap.json';

@Injectable({
  providedIn: 'root',
})
export class RegisterSvgIconsService {
  constructor(private iconLibraries: NbIconLibraries) {}

  async register() {
    this.iconLibraries.registerSvgPack('fci', icons);
  }
}
